import { Badge as _Badge, BadgeProps as _BadgeProps } from "reactstrap";

export const Badge = _Badge;

export type BadgeProps = _BadgeProps;
